export default { sha: '63279a18b7aa620331c312cc2b4b7f9d3181d5b0', buildNumber: 'undefined' }
